import { ReactNode } from 'react';
import {
  Stepper as MUIStepper,
  StepperProps as MUIStepperProps,
} from '@mui/material';

import Step from './Step';
import StepLabel from './StepLabel';

type AtomMUIProps = {
  children?: ReactNode;
  activeStep?: number;
  orientation?: 'horizontal' | 'vertical';
};

export type StepperProps = AtomMUIProps;

export const Stepper = (props: StepperProps) => {
  const MUIProps: MUIStepperProps = props;

  return <MUIStepper {...MUIProps} />;
};

Stepper.Step = Step;
Stepper.StepLabel = StepLabel;

export default Stepper;
